import { SHOW_BREADCRUMBS_LOGIN } from '../actions/show-breadrumbs-login';
import { SET_VIEW_MODE } from '../actions/set-view-mode';

const initialState = {
  showLogin: true,
};

export default function breadcrumbsWidget(state = initialState, action = {}) {
  switch (action.type) {
    case SHOW_BREADCRUMBS_LOGIN:
      return {
        showLogin: action.payload,
      };
    case SET_VIEW_MODE:
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/breadcrumbs-widget.js